import { createContext } from 'react';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

type MyCardsLayoutContextValue = {
  selectedCampaignSlug?: string;
  defaultRarity: Rarity;
  rewardsBannerHeight?: number;
};

export const MyCardsLayoutContext = createContext<MyCardsLayoutContextValue>({
  defaultRarity: Rarity.limited,
  rewardsBannerHeight: 0,
});
